import React from "react";
import { FaGithub, FaLinkedin, FaRss } from "react-icons/fa";
import { SiInfoq } from "react-icons/si";
import "./footer.style.css";

// Phase A.5: rebuilt footer.
//   Was: hardcoded "\u00a9 ANAND KUMAR JHA" \u2014 wrong name, looked
//        like a template artifact.
//   Now: tight mono one-liner with name, year, and 4 outbound links.
const FooterPanel = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <span className="site-footer-copy">
          {"\u00a9"} {year} Dhruv Agnihotri
        </span>
        <span className="site-footer-divider" aria-hidden="true">
          {"\u00b7"}
        </span>
        <span className="site-footer-tag">
          Built &amp; maintained in Seattle
        </span>
        <nav className="site-footer-links" aria-label="Footer">
          <a
            href="https://github.com/Dhruvagnihotri"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/dagni/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://www.infoq.com/articles/dpop-key-storage-unsolved-problem/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="InfoQ"
          >
            <SiInfoq />
          </a>
          <a
            href="/rss.xml"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="RSS feed"
          >
            <FaRss />
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default FooterPanel;
